var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"object-link"},[_vm._v(" "+_vm._s(_vm.element)+" "),(_vm.element)?_c('i',{staticClass:"fa-light fa-copy cursor-pointer",on:{"click":function($event){$event.stopPropagation();return _vm.copy.apply(null, arguments)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }